import { JetpacB2BApi } from 'api' // NOTE: Assuming a B2B-specific API client exists. Please replace with the correct one.

export interface IWalletAdjustmentBackendData {
  // company_name: string
  company_id: string
  form_date?: string
  to_date?: string
}

export interface IWalletAdjustmentSetBackendDataPayload {
  tenant_id: string
  transaction_amount: number
  type: string
  reference_no: string
  created_by: string
  comment: string
}

class WalletAdjustmentApi {
  static async getWalletAdjustment(
    faberToken: string,
    searchTerm: IWalletAdjustmentBackendData
  ) {
    const queryParams = new URLSearchParams()
    queryParams.append('company_id', searchTerm.company_id)
    if (searchTerm.form_date) {
      queryParams.append('form_date', searchTerm.form_date)
    }
    if (searchTerm.to_date) {
      queryParams.append('to_date', searchTerm.to_date)
    }

    const url = `wallet-ledger/adjustment?${queryParams.toString()}`
    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async addWalletAdjustment(
    faberToken: string,
    body: IWalletAdjustmentSetBackendDataPayload
  ) {
    return JetpacB2BApi.httpPost(
      `wallet-ledger`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
}

export default WalletAdjustmentApi
